export class Result<T = any> {
  isSuccess: boolean;
  isFailure: boolean;
  data: T | null;
  error: unknown;
  key: string | null;

  constructor(isSuccess: boolean, data: T | null, error: unknown, key: string | null = null) {
    this.isSuccess = isSuccess;
    this.isFailure = !isSuccess;
    this.data = data;
    this.error = error;
    this.key = key;
  }

  static success<T>(data: T, key: string | null = null): Result<T> {
    return new Result<T>(true, data, null, key);
  }

  static failure<T = any>(error: unknown, data: T | null = null): Result<T> {
    return new Result<T>(false, data, error);
  }
}
